module.exports = __webpack_public_path__ + "static/img/18.c08340e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/zh/18.png
// module id = T4jV
// module chunks = 0